import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  ButtonWrapper,
  ModalDescription,
  ModalHeader,
  ModalTitle,
  StyledBox,
} from "./style";
import CustomButton from "../../common/button/CustomButton";
import { useNavigate } from "react-router-dom";
import profile from "../../../assets/images/featured-icon.png";
import theme from "../../../theme";

export default function CompleteProfileModal({ open, handleClose }) {
  const navigate = useNavigate();
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <ModalHeader>
          <img src={profile} alt="profile" loading="lazy" />
          {/* <CloseBtn onClick={handleClose}>x</CloseBtn> */}
        </ModalHeader>
        <ModalTitle>Complete Your Profile</ModalTitle>
        <ModalDescription>
          To proceed, please complete your profile. These details are essential
          for order handling, delivery coordination, and account security.
        </ModalDescription>
        <ButtonWrapper>
          <CustomButton
            btntype={"white"}
            color={theme.palette.custom.primary}
            btnLabel={"Get Started"}
            onClick={() => {
              navigate("/dashboard/profile", { state: { editProfile: true } });
              handleClose();
            }}
          />
        </ButtonWrapper>
      </StyledBox>
    </Modal>
  );
}
